// errors
export const ERROR_MENU_PERMISSION_DENIED = "เสียใจด้วย คุณไม่มีสิทธิ์เข้าถึงเมนู"
export const ERROR_NOT_ALLOW_VOTE_MEM = "วันเลือกตั้งนี้ สำหรับเลือกตั้ง ผ.ถ. เท่านั้น"
export const ERROR_NOT_ALLOW_VOTE_PRES = "วันเลือกตั้งนี้ สำหรับเลือกตั้ง ส.ถ. เท่านั้น"
// suggestions
export const CONTACT_ADMIN = "กรุณาติดต่อส่วนกลางเพื่อขอสิทธิ์ในการเข้าเมนูดังกล่าว"